import axios from 'axios';

import {MitEventBus} from '../../main.js';

class MitUserService {
  constructor() {
  }

  getRoleNames() {
    return new Promise ((resolve, reject) => {

      axios.get('/api/v1/users/rolenames')
        .then((response) => {
            return resolve(response.data);
        })
        .catch((error) => {
          return reject(error.response.data);
        });

    });
  }
  getNewDefaultUser(){
    return {
      csailId: '',
      csailEmail: '',
      role: 0,
      groups:[],
      fname: '',
      lname: ''
    };
  }

  getUsers(page, pageSize, filters) {
    return new Promise ((resolve, reject) => {
      let url = '/api/v1/users/';

      filters = filters || {};
      url = this.updateQueryStringParameter(url, 'page', page);
      url = this.updateQueryStringParameter(url, 'pageSize', pageSize);
      url = this.updateQueryStringParameter(url, 'csailId', filters.csailId);
      url = this.updateQueryStringParameter(url, 'csailEmail', filters.csailEmail);
      url = this.updateQueryStringParameter(url, 'fname', filters.fname);
      url = this.updateQueryStringParameter(url, 'lname', filters.lname);

      axios.get(url)
        .then((response) => {
            response.data.total = parseInt(response.data.total);//convert total to a number
            return resolve(response.data);
        })
        .catch((error) => {
          return reject(error.response.data);
        });

    });
  }

  updateQueryStringParameter(uri, key, value) {
    if(typeof(value) === "undefined" || value === null) return uri;//if not defined ignore

    let re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    let separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
      return uri.replace(re, '$1' + key + "=" + value + '$2');
    }
    else {
      return uri + separator + key + "=" + value;
    }
  }

  saveUser(user) {
    return new Promise ((resolve, reject) => {

      axios.post('/api/v1/users/', user)
        .then((response) => {
            return resolve(response.data);
        })
        .catch((error) => {
          return reject(error.response.data);
        });

    });
  }

}

export default new MitUserService();
